export const UserColors = [
    '#bc46cd',
    '#0589ff',
    '#24e99e',
    '#fe7930',
    '#f02b84',
]
